<template>
  <el-row class="articleList">
    <el-col :span="24">
      <el-card shadow="never" class="article-card margin-bottom-20">
        <template slot="header">
          <div class="themeButton">通知公示</div>
          <el-select
            v-model="channelId"
            placeholder="请选择"
            clearable
            style="float: right"
            @change="channelChange"
            @clear="channelClear"
          >
            <el-option
              v-for="item in channelTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
        <ul class="articleUl">
          <li
            class="articleLi"
            v-for="item in articleList"
            :key="item.articleId"
          >
            <el-row>
              <el-col :span="1">
                <span class="articleType">{{ item.extendFeild3 }}</span>
              </el-col>
              <el-col :span="19" class="articleTitle">
                <span
                  @click="checkArticleInfo(item.articleId)"
                  class="articleTitleItem"
                  >{{ item.articleTitle }}</span
                >
              </el-col>
              <el-col :span="4" class="articleTime">
                <span>{{ item.publishTime }}</span>
              </el-col>
            </el-row>
          </li>
        </ul>
        <el-pagination
          popper-class="pageclass"
          class="tablePagination"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="query.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total,sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { channelIdList } from "../../utils/staticDict";
import { URL_CHANNEL_LIST_BYIDS } from "../../utils/api";
import util from "../../utils/util";

export default {
  name: "ArticleList",
  data() {
    return {
      channelTypeList: [
        { label: "通知", value: channelIdList.notice },
        { label: "公示", value: channelIdList.publicity },
      ],
      query: {
        currentPage: 1,
        pageSize: 10,
      },
      channelIds: [],
      channelId: "",
      total: 0,
      articleList: [],
    };
  },
  methods: {
    getArticleListByIds() {
      let Url = util.getAjaxUrl("axiosThree");
      let params = {
        ...this.query,
        t: {
          channels: this.channelIds,
          publishSign: "2",
        },
      };

      this.$http.post(Url + URL_CHANNEL_LIST_BYIDS, params).then((resp) => {
        if (resp.data.success) {
          this.articleList = resp.data.data.data;
          this.total = resp.data.data.total;
        } else {
          this.$alert("获取文章列表失败");
        }
      });
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getArticleListByIds();
    },
    handlePageChange(page) {
      this.query.currentPage = page;
      this.getArticleListByIds();
    },
    channelChange(value) {
      if (value) {
        this.channelIds = [value];
        this.getArticleListByIds();
      }
    },
    channelClear() {
      this.channelIds = [channelIdList.notice, channelIdList.publicity];
      this.getArticleListByIds();
    },
    checkArticleInfo(id) {
      let design = this.$router.resolve("/article/content?articleId=" + id);
      window.open(design.href, "_blank");
    },
  },
  mounted() {
    this.channelIds = [channelIdList.notice, channelIdList.publicity];
    this.getArticleListByIds();
  },
};
</script>

<style scoped lang="less">
@import "../../styles/theme";
.articleList {
  padding-top: 20px;
  width: 96%;
  margin: 0 auto;
  .article-card {
    border: 1px solid #cccccc;
    /deep/.el-card__header {
      padding: 10px;
      border-bottom: 1px solid #cccccc;
    }
    /deep/.el-card__body {
      padding: 0;
      .articleUl {
        list-style: none;
        padding: 0px 10px;
      }
      .articleLi {
        padding: 6px;
        margin-bottom: 7px;
        .articleType {
          background-color: @theme-color;
          border-color: @theme-color;
          color: #ffffff;
          padding: 9px 3px;
          border-radius: 5px;
          line-height: 30px;
        }
        .articleTitle {
          border-bottom: 1px dashed #999;
          line-height: 30px;
          padding: 2px 0;
          white-space: nowrap;
          overflow: hidden;
          color: #606266;
          text-overflow: ellipsis;
          .articleTitleItem {
            font-size: 16px;
            cursor: pointer;
          }
          .articleTitleItem:hover {
            color: @theme-color;
          }
        }
        .articleTime {
          border-bottom: 1px dashed #999;
          line-height: 30px;
          padding: 2px 0;
          text-align: right;
          height: 3.05em;
          span {
            color: #606266;
            font-size: 16px;
          }
        }
      }
      .tablePagination {
        padding: 10px;
        text-align: center;
        .el-pager li.active {
          color: @theme-color;
        }
      }
    }
  }
}
.themeButton {
  margin-left: 45%;
  color: @theme-color;
  padding: 8px 11px;
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
}
/deep/.el-select .el-input.is-focus .el-input__inner {
  border-color: @theme-color;
}
/deep/.el-pagination__sizes .el-input .el-input__inner:hover {
  border-color: @theme-color;
}
</style>
